import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import * as styles from './styles.css';
import { ErrorPopover } from '../ErrorPopover';
import { widgetContext } from '../../context/widgetContext';
import { DesktopInput } from './DesktopInput';
import { MobileInput } from './MobileInput';
import { FilterWrapper } from '../packages/FilterWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
export var AreaInput = function AreaInput(props) {
  var errorMessage = props.errorMessage;

  var _React$useContext = React.useContext(widgetContext),
      isDesktop = _React$useContext.isDesktop;

  return /*#__PURE__*/_jsx(FilterWrapper, {
    isFirstFilter: props.isFirstFilter,
    isLastFilter: props.isLastFilter,
    children: /*#__PURE__*/_jsx("div", {
      className: isDesktop ? styles['container-not-mobile'] : styles['container-mobile'],
      children: /*#__PURE__*/_jsx(ErrorPopover, {
        tooltipContent: errorMessage,
        placement: "top-end",
        children: isDesktop ? /*#__PURE__*/_jsx(DesktopInput, _objectSpread({}, props)) : /*#__PURE__*/_jsx(MobileInput, _objectSpread({}, props))
      })
    })
  });
};
AreaInput.displayName = 'AreaInput';